// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__15_oc","header":"MessagesList_header__3ujBU","chat":"MessagesList_chat__h7rdO"};